export default "__VITE_ASSET__xR3Rd4hE__"